module.exports = {
          srcSet: __webpack_public_path__ + "18dfa108be8b00f44652ef6c9232727f-470.png"+" 470w",
          images:[ {path: __webpack_public_path__ + "18dfa108be8b00f44652ef6c9232727f-470.png",width: 470,height: 334}],
          src: __webpack_public_path__ + "18dfa108be8b00f44652ef6c9232727f-470.png",
          toString:function(){return __webpack_public_path__ + "18dfa108be8b00f44652ef6c9232727f-470.png"},
          
          width: 470,
          height: 334
        }